export const DAILYMOTION_API_BASE = 'https://api.dailymotion.com';
export const INVALID_SLUG_FORMAT_ERROR = 'INVALID_SLUG_FORMAT';
